import { Show, SimpleShowLayout, TextField } from "react-admin";
import { ShowHeader } from "../../utils/header";

export function ArtistShow(): JSX.Element {
    return (
        <Show title={<ShowHeader field="fullName" />}>
            <SimpleShowLayout>
                <TextField source="id" />
                <TextField source="fullName" />
            </SimpleShowLayout>
        </Show>
    );
}
